import React from "react";
import { Link } from "react-router-dom";
import "./ServicePages.css";

const QuotePage = () => {
  return (
    <div className="page-shell">
      <div className="page-wrap">
        <div className="page-hero">
          <p className="page-eyebrow">Book a walkthrough</p>
          <h1>Get a Pro Quote</h1>
          <p className="lead">
            Tell us about your wall, rental, or refresh. We’ll respond with the right SKU,
            timeline, and the materials plan so you know exactly what you’re getting.
          </p>
          <div className="pill-row">
            <span className="pill">Houston · Austin</span>
            <span className="pill">Interior decals</span>
            <span className="pill">Fast Flash refresh</span>
          </div>
        </div>

        <div className="quote-box">
          <h2>Tell us about your project</h2>
          <form className="quote-form">
            <label>
              Name
              <input type="text" name="name" placeholder="Your name" />
            </label>
            <label>
              Email
              <input type="email" name="email" placeholder="you@example.com" />
            </label>
            <label>
              Phone
              <input type="tel" name="phone" placeholder="(555) 123-4567" />
            </label>
            <label>
              Service
              <select name="service">
                <option value="">Choose an option</option>
                <option value="interior-decals">J3 Interior Decals</option>
                <option value="fast-flash">J3 Fast Flash Touch-Up</option>
                <option value="texture-lab">Texture Lab (early access)</option>
              </select>
            </label>
            <label>
              Location
              <input type="text" name="location" placeholder="City / neighborhood" />
            </label>
            <label>
              Wall or room details
              <textarea
                name="details"
                placeholder="Wall dimensions, room use, timelines, any photos you can share."
              />
            </label>
            <button type="submit" className="btn primary">
              Send request
            </button>
          </form>
          <p className="note">
            We’ll review and respond quickly. If you have photos, reply to our email with them
            and we’ll map the stencil or refresh plan.
          </p>
        </div>

        <div className="section-block">
          <h2>Curious how we price projects?</h2>
          <p>See how J3 Innovations builds painting estimates in Kingwood and Houston—scope, prep, and products explained.</p>
          <Link
            to="/blog/how-we-build-your-painting-estimate-kingwood"
            className="cta-inline"
          >
            Read the estimate guide →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default QuotePage;
